module.exports = __webpack_public_path__ + "img/background_c4-1_mask.62ba4f2c.jpg";